import { render } from "./Quienes.vue?vue&type=template&id=020b8d2e&scoped=true"
const script = {}

import "./Quienes.vue?vue&type=style&index=0&id=020b8d2e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-020b8d2e"

export default script